import {
    FaSatelliteDish,
    FaChartPie,
    FaUsers,
    FaFileInvoiceDollar,
    FaWifi,
    FaChartLine,
    FaGear,
    FaLock,
    FaArrowUp,
    FaArrowDown,
  } from 'react-icons/fa6'
  
  const menuItems = [
    { icon: FaChartPie, label: 'Dashboard', active: true },
    { icon: FaUsers, label: 'Pelanggan' },
    { icon: FaFileInvoiceDollar, label: 'Tagihan' },
    { icon: FaWifi, label: 'PPPoE' },
    { icon: FaChartLine, label: 'Laporan' },
    { icon: FaGear, label: 'Pengaturan' },
  ]
  
  const stats = [
    { label: 'Pelanggan Aktif', value: '1,248', change: '+12%', up: true },
    { label: 'Pendapatan Bulan Ini', value: 'Rp 62.4 Jt', change: '+8%', up: true },
    { label: 'Tidak Aktif', value: '47', change: '-5%', up: false },
  ]
  
  const barData = [55, 40, 75, 50, 85, 65, 90, 45, 70, 60, 80, 50]
  
  const transactions = [
    { name: 'Ahmad Fauzi', pkg: 'Paket 30 Mbps', status: 'Lunas', color: 'text-emerald-400' },
    { name: 'Siti Nurhaliza', pkg: 'Paket 50 Mbps', status: 'Menunggu', color: 'text-amber-400' },
    { name: 'Budi Santoso', pkg: 'Paket 20 Mbps', status: 'Lunas', color: 'text-emerald-400' },
  ]
  
  export default function DashboardMockup() {
    return (
      <div className="relative">
        <div
          className="absolute -inset-4 bg-ocean-600/8 blur-3xl rounded-3xl"
          aria-hidden="true"
        />
        <div
          className="relative bg-navy-800 rounded-2xl border border-navy-500/40 overflow-hidden shadow-2xl shadow-black/40"
          style={{ animation: 'pulseGlow 5s ease-in-out infinite' }}
        >
          {/* Browser Chrome */}
          <div className="flex items-center gap-2 px-4 py-3 bg-navy-700/60 border-b border-navy-500/30">
            <div className="w-3 h-3 rounded-full bg-red-500/70" />
            <div className="w-3 h-3 rounded-full bg-amber-500/70" />
            <div className="w-3 h-3 rounded-full bg-emerald-500/70" />
            <div className="ml-4 flex-1 bg-navy-900/60 rounded-lg px-4 py-1.5 text-xs text-slate-custom flex items-center gap-2">
              <FaLock className="text-ocean-700 text-[10px]" />
              app.radiustrend.id/dashboard
            </div>
          </div>
  
          <div className="flex" style={{ minHeight: 340 }}>
            {/* Sidebar */}
            <div className="w-44 bg-navy-900/60 p-3 border-r border-navy-500/20 flex-shrink-0">
              <div className="flex items-center gap-2 px-2 py-3 mb-4">
                <div className="w-7 h-7 rounded-lg bg-gradient-to-br from-ocean-800 to-ocean-600 flex items-center justify-center">
                  <FaSatelliteDish className="text-white text-[10px]" />
                </div>
                <span className="font-display font-bold text-xs text-white">
                  RadiusTrend
                </span>
              </div>
              <div className="space-y-1">
                {menuItems.map((m, i) => {
                  const Icon = m.icon
                  return (
                    <div
                      key={i}
                      className={`flex items-center gap-2.5 px-3 py-2 rounded-lg text-[11px] transition-colors ${
                        m.active
                          ? 'bg-ocean-800/20 text-ocean-400 border border-ocean-600/20'
                          : 'text-slate-custom hover:text-slate-300'
                      }`}
                    >
                      <Icon className="w-4 text-center text-[10px]" />
                      <span>{m.label}</span>
                    </div>
                  )
                })}
              </div>
            </div>
  
            {/* Main Content */}
            <div className="flex-1 p-4 space-y-4 min-w-0">
              {/* Stats Cards */}
              <div className="dash-row" style={{ '--d': '0.3s' }}>
                <h3 className="text-sm font-semibold text-white mb-3">
                  Overview
                </h3>
                <div className="grid grid-cols-3 gap-2.5">
                  {stats.map((s, i) => (
                    <div
                      key={i}
                      className="bg-navy-700/40 rounded-xl p-3 border border-navy-500/20"
                    >
                      <div className="text-[10px] text-slate-custom mb-1">
                        {s.label}
                      </div>
                      <div className="text-sm font-bold text-white">
                        {s.value}
                      </div>
                      <div
                        className={`text-[10px] mt-1 ${
                          s.up ? 'text-emerald-400' : 'text-red-400'
                        }`}
                      >
                        {s.up ? (
                          <FaArrowUp className="inline text-[8px] mr-0.5" />
                        ) : (
                          <FaArrowDown className="inline text-[8px] mr-0.5" />
                        )}
                        {s.change}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
  
              {/* Bar Chart */}
              {/* <div className="dash-row" style={{ '--d': '0.6s' }}>
                <h3 className="text-[11px] font-semibold text-white mb-2">
                  Pendapatan 12 Bulan Terakhir
                </h3>
                <div
                  className="bg-navy-700/40 rounded-xl p-3 border border-navy-500/20 flex items-end gap-[5px]"
                  style={{ height: 90 }}
                >
                  {barData.map((h, i) => (
                    <div
                      key={i}
                      className="flex-1 rounded-t-sm bg-gradient-to-t from-ocean-800 to-ocean-500/80 transition-all hover:from-ocean-700 hover:to-ocean-400"
                      style={{
                        '--h': h + '%',
                        animationDelay: 0.8 + i * 0.05 + 's',
                      }}
                    />
                  ))}
                </div>
              </div> */}
  
              {/* Transactions */}
              <div className="dash-row" style={{ '--d': '0.9s' }}>
                <h3 className="text-[11px] font-semibold text-white mb-2">
                  Transaksi Terbaru
                </h3>
                <div className="bg-navy-700/40 rounded-xl border border-navy-500/20 overflow-hidden">
                  {transactions.map((t, i) => (
                    <div
                      key={i}
                      className={`flex items-center justify-between px-3 py-2 ${
                        i < 2 ? 'border-b border-navy-500/15' : ''
                      }`}
                    >
                      <div>
                        <div className="text-[11px] text-white font-medium">
                          {t.name}
                        </div>
                        <div className="text-[10px] text-slate-custom">
                          {t.pkg}
                        </div>
                      </div>
                      <span className={`text-[10px] font-semibold ${t.color}`}>
                        {t.status}
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }